import React from "react";

const Input = ({
  label,
  name,
  type = "text",
  value = "",
  onChange,
  placeholder = "",
  error = "",
  helperText = "",
  required = false,
  disabled = false,
  readOnly = false,
  autoComplete,
  className = "",
  ...props
}) => {
  const inputId = `input-${name}`;

  return (
    <div className={`ui-form-group ${className}`}>
      {label && (
        <label htmlFor={inputId} className="ui-form-label">
          {label}

          {required && (
            <span className="ui-form-required">*</span>
          )}
        </label>
      )}

      <input
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        autoComplete={autoComplete}
        className={`ui-input ${error ? "ui-input-error" : ""}`}
        aria-invalid={Boolean(error)}
        aria-describedby={
          error
            ? `${inputId}-error`
            : helperText
            ? `${inputId}-helper`
            : undefined
        }
        {...props}
      />

      {error && (
        <p id={`${inputId}-error`} className="ui-form-error">
          {error}
        </p>
      )}

      {!error && helperText && (
        <p id={`${inputId}-helper`} className="ui-form-helper">
          {helperText}
        </p>
      )}
    </div>
  );
};

export default Input;